module.exports = __webpack_public_path__ + "img/03_no.cacdf6ba.svg";